<div [class]="containerClass">
  <div class="animate-pulse">
    <!-- Table rows skeleton -->
    <div [class]="rowSpacing">
      @for (item of skeletonRows; track item) {
      <div [class]="rowClass">
        @for (col of skeletonColumns; track col) {
        <div
          [class]="rowHeight + ' bg-gray-200 rounded'"
          [ngClass]="getColumnWidth(col)"
        ></div>
        }
      </div>
      }
    </div>
  </div>
</div>
